import { render, staticRenderFns } from "./orderDetailCardNew.vue?vue&type=template&id=126dde4c&scoped=true&"
import script from "./orderDetailCardNew.vue?vue&type=script&lang=js&"
export * from "./orderDetailCardNew.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailCardNew.vue?vue&type=style&index=0&id=126dde4c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126dde4c",
  null
  
)

export default component.exports